// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"381":"f966dac4","453":"ad94d44d","871":"86de569c","933":"5100e7c4"}[chunkId] + ".chunk.js";
};